import Vue from 'vue';
import Vuex from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agents from './modules/agents';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auth from './modules/auth';
import auditlogs from './modules/auditlogs';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import companies from './modules/companies';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import queueStats from './modules/queueStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import copilot from './modules/copilot';
import csat from './modules/csat';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import labelsCrm from './modules/labelsCrm';
import macros from './modules/macros';
import posts from './modules/posts';
import featureFlag from './modules/featureFlag';

import groups from './modules/groups';
import kanbanfunnel from './modules/kanbanfunnel';
import templates from './modules/templates';
import tickets from './modules/ticket';
import crmActivities from './modules/crmActivities';
import customSurveys from './modules/customSurveys';
import onboard from './modules/onboard';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import * as VueGoogleMaps from 'vue2-google-maps';
import catalog from './modules/catalog';
import campaignsContactList from './modules/campaignsContactList';
import campaignsFlow from './modules/campaignsFlow';

import wise from './modules/wise';
import quotation from './modules/quotation';
import ticketLogs from './modules/ticketLogs';
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

import money from 'v-money';

Vue.use(money, { precision: 2 });

const plugins = [];

if (window.logRocketProjectId) {
  LogRocket.init(window.logRocketProjectId);
  const logRocketPlugin = createPlugin(LogRocket, function (mutation) {
    const eventsToIgnore = ['SET_CURRENT_USER', 'AUTHENTICATE', 'CLEAR_USER'];
    if (eventsToIgnore.includes(mutation.type)) {
      return null;
    }

    return mutation;
  });

  plugins.push(logRocketPlugin);
}

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: 'places',
  },
});

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    accounts,
    agentBots,
    agents,
    articles,
    attributes,
    auth,
    automations,
    auditlogs,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    companies,
    templates,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    queueStats,
    conversationTypingStatus,
    conversationWatchers,
    copilot,
    csat,
    customViews,
    dashboardApps,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    featureFlag,
    integrations,
    labels,
    labelsCrm,
    macros,
    onboard,
    posts,
    groups,
    kanbanfunnel,
    tickets,
    ticketLogs,
    crmActivities,
    customSurveys,
    notifications,
    portals,
    reports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    catalog,
    campaignsContactList,
    campaignsFlow,
    wise,
    quotation
  },
  plugins,
});
